import React, { useEffect, useState } from 'react';
import axios from 'axios';

import servicesApi from '../../seller-apis/servicesApi';
import api from '../../seller-apis/api';
import BrandDropDown from './BrandDropDown';
import FileUploader from './FileUploader';
import Button from './Button';
import './brand.css';
import { Modal } from 'react-bootstrap';
import { useHistory, NavLink, useParams } from 'react-router-dom';
import Loader from '../common/Loader';
import convertFileToWebP from '../../utilities/convertFileToWebP';
import { useAlert } from 'react-alert';
import { countries } from '../../utilities/countries';
import BrandStepTimeLine from './BrandStepTimeline';

const UPLOAD_TRADEMAKE_CERTIFICATE = "*Upload Certificate";
const IN_PDF_JPEG_FORMAT = "(as PDF or Image, 2Mb max)";
const UPLOAD_REGISTERED_LOGO = "*Upload Logo";
const MAX_SIZE_500_KB = "(Max Image Size 500 Kb)";
const UPLOAD_BANNER = "Upload Banner";
const ENTER_YOUR_BRAND_NAME = "Brand Name";
const TYPE_YOUR_BRAND_NAME = "*Type your Brand Name";
const TNC_FIRST = "By continuing, I agree to Toolsvilla";
const TNC_SECOND = "Terms of Use & Privacy Policy";
const REGISTER_BUTTON = "Register & Continue";
const REQUIRED = "*Required";
const UPLOAD_CERIFICATE_DESC = "*Upload Trademark Certificate/ Brand Supporting Document";
const UPLOAD_LOGO_DESC = "*Upload Registered Logo";
const UPLOAD_BANNER_DESC = "Upload Brand Banner";


function BrandStep1() {
    const { id } = useParams();
    const alert = useAlert();
    const [search, setSearch] = useState('');
    const [brandList, setBrandList] = useState([]);
    const [brandIdIndex, setBrandIdIndex] = useState('');
    const [tradeMarkCertFile, setTradeMarkCertFile] = useState(null);
    const [registeredLogoFile, setRegisteredLogoFile] = useState(null);
    const [registeredBannerFile, setRegisteredBannerFile] = useState(null);
    const [manufacturerName, setManufacturerName] = useState(null);
    const [newBrandFlag, setNewBrandFlag] = useState(false);

    const [brandError, setBrandError] = useState(null);
    const [manufacturerError, setManufacturerError] = useState(null);
    const [brandAddressError, setBrandAddressError] = useState(null);
    const [tradeMarkCertFileError, setTradeMarkCertFileError] = useState(null);
    const [registeredLogoFileError, setRegisteredLogoFileError] = useState(null);
    const [registeredBannerFileError, setRegisteredBannerFileError] = useState(null);

    const [loader, setLoader] = useState(false);

    const [importer, setImporter] = useState(null);
    const [packer, setPacker] = useState(null);
    const [countryOfOrigin, setCountryOfOrigin] = useState("IN");
    const [brandAddress, setBrandAddress] = useState(null);
    const [brandName, setBrandName] = useState(null);

    const [trademarkCertName, setTrademarkCertName] = useState("");
    const [registeredLogoName, setRegisteredLogoName] = useState("");
    const [registeredBannerName, setRegisteredBannerName] = useState("");

    const [isBrandEditable, setIsBrandEditable] = useState(true)


    const history = useHistory()
    useEffect(() => {
        fetchBrands()
        if (id) {
            setIsBrandEditable(false)
            fetchBrand(id)
        }

    }, [])


    const fetchBrand = async (id) => {
        try {
            const res = await api.TradeMark.getBrandById(id);
            console.log(res.data.data.records)
            const record = res?.data?.data?.records
            setCountryOfOrigin(record?.originCountry)
            setBrandName(record?.brandName)
            setBrandAddress(record?.brandAddress)
            setManufacturerName(record?.manufacturerName)
            setPacker(record?.packer)
            setImporter(record?.importer)
            setRegisteredBannerName(record?.banner)
            setRegisteredLogoName(record?.registeredLogo)
            setTrademarkCertName(record?.trademarkCert)
        } catch (error) {
            console.error(error)
        }
    }

    const submit = async () => {
        try {
            setLoader(true)
            if (validation()) {
                //Create Object
                let brandN = brandName;
                let manufacturerId = "";
                if (brandIdIndex.toString().length) {
                    brandN = brandList[brandIdIndex].name
                    manufacturerId = brandList[brandIdIndex].manufacturerId
                }
                else {
                    const isExistingBrand = brandList.find(
                        (item) => item.name.toLowerCase() === brandN.toLowerCase()
                    );
                    if (isExistingBrand) {
                        brandN = isExistingBrand.name
                        manufacturerId = isExistingBrand.manufacturerId
                    }
                }
                let brandData = {
                    brandName: brandN.trim(),
                    brandAddress: brandAddress.trim(),
                    originCountry: countryOfOrigin ? countryOfOrigin:"",
                    packer: packer ? packer.trim():"",
                    manufacturerId: manufacturerId,
                    manufacturerName: manufacturerName.trim(),
                    importer: importer ? importer.trim():""
                }


                //Check if trademark file changes then only upload it
                if (trademarkCertName) {
                    brandData["trademarkCert"] = trademarkCertName//tradeMarkCert.data.split('?')[0]
                }

                //Check if logo file changes then only upload it
                if (registeredLogoName)
                    brandData["registeredLogo"] = registeredLogoName

                //Check if banner file changes then only upload it
                if (registeredBannerName)
                    brandData["banner"] = registeredBannerName


                //Call API                
                const res = id ? await api.TradeMark.updateBrandDets({ id: id, data: brandData })
                    : await api.TradeMark.add(brandData);
                setLoader(false)
                if (Object.keys(res?.data?.data).length > 0) {
                    history.push(`/apply-brand/2/${res?.data?.data?._id}`)
                } else {
                    alert.info(res?.data?.message)
                }
            }
        } catch (error) {
            console.error(error)
            alert.info("Some error has occurred!")
        } finally {
            setLoader(false)
        }

    }

    const validation = () => {
        resetErrors()
        let formValidation = true;
        if (brandName === "" || brandName === null || brandName === undefined || brandName.trim() === "") {
            setBrandError("*Please enter a valid brand name!")
            formValidation = false;
        }

        if (manufacturerName === "" || manufacturerName === null || manufacturerName === undefined || manufacturerName.trim() === "") {
            setManufacturerError("*Please enter a valid manufacturer name!")
            formValidation = false;
        }

        if (countryOfOrigin === "" || countryOfOrigin === null || countryOfOrigin === undefined) {
            console.log("klfn")
            formValidation = false;
        }

        if (brandAddress === "" || brandAddress === null || brandAddress === undefined || brandAddress.trim() === "") {
            setBrandAddressError("*Please enter a valid brand address!")
            formValidation = false;
        }

        if (!trademarkCertName) {
            setTradeMarkCertFileError("*Required!")
            formValidation = false
        }

        if (!registeredLogoName) {
            setRegisteredLogoFileError("*Required!")
            formValidation = false
        }

        return formValidation;
    }

    const fetchBrands = async () => {
        const res = await api.TradeMark.getBrands();
        setBrandList(res.data.data)
    }

    const handleDropDownClick = (data) => {
        // console.log(data)
        setImporter(data?.importer || importer)
        setPacker(data?.packer || packer)
        setBrandAddress(data?.address || brandAddress)
        setCountryOfOrigin(data?.originCountry || countryOfOrigin)
        setManufacturerName(data?.mfg || manufacturerName)
        setRegisteredLogoName(data?.logo || registeredLogoName)
        setRegisteredBannerName(data?.brandBanners?.[0] || registeredBannerName)
    }

    const resetErrors = () => {
        setBrandAddressError(null)
        setRegisteredLogoFileError(null)
        setManufacturerError(null)
        setBrandAddressError(null)
        setTradeMarkCertFileError(null)
    }

    return (
        <div className='brand-step-main-cntn'>
            <div className='container px-3'>
                <div className='row mb-5 mt-5 f-c-r'>
                    <div className='text-center'>

                        {/* <div className='brand-tag'></div> */}
                        <BrandStepTimeLine activeStep={1} />
                    </div>
                    <div className='col-md-12 col-xs-12 col-sm-12 brand-left-cntn select-container'>
                        {/* 1 row */}
                        <div className='row'>
                            <div className='col-4'>
                                <BrandDropDown
                                    search={search}
                                    setSearch={setSearch}
                                    label={ENTER_YOUR_BRAND_NAME}
                                    state={brandIdIndex}
                                    setState={setBrandIdIndex}
                                    list={brandList}
                                    newBrandLabel={TYPE_YOUR_BRAND_NAME}
                                    newBrand={brandName}
                                    setNewBrand={setBrandName}
                                    newBrandFlag={newBrandFlag}
                                    setNewBrandFlag={setNewBrandFlag}
                                    setError={setBrandError}
                                    handleDropDownClick={handleDropDownClick}
                                    isEditable={isBrandEditable}
                                    error={brandError}
                                />
                            </div>

                            <div className='col-4'>
                                <label>Manufacturer *</label>
                                <input
                                    type="text"
                                    placeholder="Enter Manufacturer Name"
                                    onChange={(e) => setManufacturerName(e.target.value)}
                                    value={manufacturerName}
                                />
                                 {
                                    manufacturerError ?
                                        <span className="text-danger" style={{  fontFamily: 'Inter', fontWeight: '500' }}>{manufacturerError}</span>
                                        : null
                                }
                            </div>
                            <div className='col-4'>
                                <label>Country of Origin *</label>
                                {/* Instead of country Name take code as value */}
                                <select id="country" value={countryOfOrigin} className={`brand-country-select ${countryOfOrigin === "" ? 'brand-country-select-placeholder' : ''}`} onChange={(e) => setCountryOfOrigin(e.target.value)}>
                                    <option key='IN' value='IN'>India</option>
                                    <option key='CN' value='CN'>China</option>
                                    <option key='DE' value='DE'>Germany</option>
                                    {Object.entries(countries).map(([code, name]) => (
                                        <>
                                            {(name === "India" || name === "China" || name === "Germany") ? <></> : <option key={code} value={code}>
                                                {name}
                                            </option>}

                                        </>
                                    ))}
                                </select>
                            </div>
                        </div>
                        {/* 2 row */}
                        <div className='row'>
                            <div className='col-4'>
                                <label>Brand Address *</label>
                                <input
                                    type="text"
                                    placeholder="Please enter Brand Address"
                                    onChange={(e) => setBrandAddress(e.target.value)}
                                    value={brandAddress}
                                />
                                {
                                    brandAddressError ?
                                        <span className="text-danger" style={{  fontFamily: 'Inter', fontWeight: '500' }}>{brandAddressError}</span>
                                        : null
                                }
                            </div>
                            <div className='col-4'>
                                <label>Packer Details(optional)</label>
                                <input
                                    type="text"
                                    placeholder="Enter Packer Details"
                                    onChange={(e) => setPacker(e.target.value)}
                                    value={packer}
                                />
                            </div>
                            <div className='col-4'>
                                <label>Importer Details(optional)</label>
                                <input
                                    type="text"
                                    placeholder="Enter Importer Details"
                                    onChange={(e) => setImporter(e.target.value)}
                                    value={importer}
                                />
                            </div>

                        </div>
                        {/* 3 row */}
                        <div className='row'>
                            <div className='col-12'>
                                <div className='brand-file-upload'>
                                    <FileUploader
                                        label={UPLOAD_TRADEMAKE_CERTIFICATE}
                                        subLabel={IN_PDF_JPEG_FORMAT}
                                        state={tradeMarkCertFile}
                                        setState={setTradeMarkCertFile}
                                        id="TRADEMARK_CERT_FILE"
                                        accept="image/*,application/pdf"
                                        fileSize={2048}
                                        setError={setTradeMarkCertFileError}
                                        error={tradeMarkCertFileError}
                                        uploadDesc={UPLOAD_CERIFICATE_DESC}
                                        mainLabel="Trademark Document *"
                                        filename={trademarkCertName}
                                        setfilename={setTrademarkCertName}
                                    />
                                    <FileUploader
                                        label={UPLOAD_REGISTERED_LOGO}
                                        subLabel={MAX_SIZE_500_KB}
                                        state={registeredLogoFile}
                                        setState={setRegisteredLogoFile}
                                        id="REGISTRATION_LOGO_FILE"
                                        accept="image/*"
                                        fileSize={500}
                                        setError={setRegisteredLogoFileError}
                                        error={registeredLogoFileError}
                                        uploadDesc={UPLOAD_LOGO_DESC}
                                        mainLabel="Brand Logo *"
                                        filename={registeredLogoName}
                                        setfilename={setRegisteredLogoName}
                                    />
                                    <FileUploader
                                        label={UPLOAD_BANNER}
                                        subLabel={MAX_SIZE_500_KB}
                                        state={registeredBannerFile}
                                        setState={setRegisteredBannerFile}
                                        id="REGISTRATION_BANNER_FILE"
                                        accept="image/*"
                                        fileSize={500}
                                        setError={setRegisteredBannerFileError}
                                        error={registeredBannerFileError}
                                        uploadDesc={UPLOAD_BANNER_DESC}
                                        mainLabel="Brand Banner (optional)"
                                        filename={registeredBannerName}
                                        setfilename={setRegisteredBannerName}
                                    />
                                </div>
                            </div>
                        </div>

                        <Button
                            value={REGISTER_BUTTON}
                            style={{ "margin": "auto" }}
                            icon={<i className={"ms-2 bi bi-arrow-right"} />}
                            handleClick={submit}
                        />
                    </div>
                </div>

            </div>
            <Loader show={loader} />
        </div>
    )

}

export default BrandStep1;